import React, { useReducer } from "react";
import accessHistoryService from "./accessHistoryService";
import { useTranslation } from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid, Typography } from "@material-ui/core";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import DefaultChip from "../../componentes/chip/DefaultChip";


const columnsAccessHistory = (t) => [
  { field: "id", visible: false },
  {
    field: "idLogin",
    textAlign: 'center',
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} labelName="id" />;
    },
    template: (props) => {
        return (
            <>
                <DefaultChip
                    style="primary"
                    label={<Typography
                        variant="body3"
                        style={{ whiteSpace: 'normal' }}>{props.idLogin}
                    </Typography>}
                />
            </>
        )
    }
  },
  {
    field: "login", 
    textAlign: 'center',
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} name="user" />;
    },
    template: (props) => {
        return (
            <>
                <DefaultChip
                    style="grey"
                    label={<Typography
                        variant="body3"
                        style={{ whiteSpace: 'normal' }}>{props.login}
                    </Typography>}
                />
            </>
        )
    }
  },
  {
    field: "menu",
    textAlign: 'center',
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} labelName="menu" />;
    },
    flex: 1,
  },
  {
    field: "registerDate",
    textAlign: 'center',
    headerTemplate: () => {
      return <IconLabelSwitch isHeader={true} name="date" />;
    },
  },
];

function reducer(state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.data }
    case "clear":
    {
      return cleanAccessHistoryState
    }
    case 'success':
      return { ...state, success: true, error: false }
    case 'error':
      return { ...state, success: false, error: true }
    case 'close_alert':
      return { ...state, success: false, error: false }
    default:
      return new Error();
  }
}


const initialAccessHistoryState = {
  idLogin: 0,
  userId: 0,
  idMenu: 0,
  startDate: new Date(),
  endDate: new Date(),
  accessHistoryRows: []
};

const cleanAccessHistoryState = {
  idLogin: 0,
  userId: 0,
  idMenu: 0,
  startDate: null,
  endDate: null,
  accessHistoryRows: []
};

export default function AccessHistory() {
  const { t } = useTranslation();

  const [accessHistory, dispatch] = useReducer(reducer, initialAccessHistoryState);
  const { idLogin, userId, idMenu, startDate, endDate, accessHistoryRows } = accessHistory

  const handleChange = ({ target: { name, value } }) => {
    dispatch({
      type: 'update',
      data: { [name]: value }
    })
    if (name === "userId") {
      searchAccessHistory();
    }
  };

  const searchAccessHistory = () => {
    const formattedData = {
      idAccessedProgram: accessHistory.idMenu,
      idLogin: accessHistory.userId,
      starDate: accessHistory.starDate == null ? '' : accessHistory.starDate ,
      endDate: accessHistory.endDate == null ? '' : accessHistory.endDate ,
      accessHistoryRows,
      ...accessHistory,
    };
    //console.log(formattedData)
    accessHistoryService
      .get(formattedData)
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          response.data[i] = { id: i, ...response.data[i] };
        }
        dispatch({
          type: 'update',
          data: { "accessHistoryRows": response.data }
        })
      })
      .catch((e) => dispatch({
        type: 'update',
        data: { "accessHistoryRows": [] }
      }));
  };

  return (
    <>
      <DefaultScreenAccordion
        title="accessHistory"
        fields={
          <GridItemContainer>
            <GridInputRow>
              <Grid item xs={12} sm={6} md={3}>
                <DefaultAutocomplete
                  name={"idLogin"}
                  onChange={handleChange}
                  value={idLogin}
                  label={t("login")}
                  defaultSize
                  useApi
                  endpoint='GetUserAutoComplete'
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <DefaultAutocomplete
                  name={"idMenu"}
                  onChange={handleChange}
                  value={idMenu}
                  label={t("Menu")}
                  defaultSize
                  useApi
                  endpoint='GetMenuAutocomplete'
                  endPointData={{ userId: userId }}
                  placeholder={t("search")}
                />
              </Grid> 
              <Grid item xs={12} sm={6} md={3}>
                <CustomDatePicker
                  id="startDatePicker"
                  name="startDate"
                  selectedDate={startDate}
                  handleChange={handleChange}
                  disableFuture={true}
                  error={
                    endDate === null &&
                    startDate < endDate
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomDatePicker
                  id="endDatePicker"
                  name="endDate"
                  selectedDate={endDate}
                  handleChange={handleChange}
                  disableFuture={true}
                  error={
                    endDate === null &&
                    startDate < endDate
                  }
                />
              </Grid>
            </GridInputRow>
            <SearchClearSaveRow
              onClickSearch={searchAccessHistory}
              onClickClear={() => dispatch({ type: 'clear' })}
            />
          </GridItemContainer>
        }
      />
      {accessHistoryRows.length > 0 ? (
        <DefaultScreenAccordion
          title="Grid"
          fields={
            <Grid item xs={12}>
              <DefaultDatagrid
                dataSource={accessHistoryRows}
                columns={columnsAccessHistory(t)}
                allowPaging={true}
                // disableSelectionOnClick={true}
              />
            </Grid>

          } />
      ) : null}
    </>

  );
};

